import type { AppVisibility, AriaDatapointType } from "owa-analytics-types";
import { getAnalyticsAddon, registerAnalyticsAddon } from "./analyticsAddons";
import type { AppVisibilityEnrichment } from "./types/AppVisibilityEnrichment";

let appVisibility: AppVisibility | undefined;

export function setAppVisibilityForEnrichment(newAppVisibility: AppVisibility): void {
    appVisibility = newAppVisibility;
    
    const addon = getAnalyticsAddon<void>("AppVisibilityEnrichment");
    if (!addon.isRegistered) {
        registerAnalyticsAddon("AppVisibilityEnrichment", enrichDatapoint);
    }
}

export function getAppVisibilityForEnrichment(): AppVisibility | undefined {
    return appVisibility;
}

const enrichDatapoint: AppVisibilityEnrichment = (datapoint: AriaDatapointType) => {
    if (!appVisibility) {
        return;
    }
    
    const propertyBag = datapoint.getPropertyBag();
    if (propertyBag) {
        propertyBag.appVisibility = appVisibility;
    }
    else {
        datapoint.addCustomProperty("appVisibility", appVisibility);
    }
};
